import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { DISTRIBUTOR_SAVE_ENDPOINT, GET_DISTRIBUTOR_DATA_ENDPOINT } from '../utils/api';
import MasterNavbar from '../components/layout/MasterNavbar';

function DistributorsAdd() {
  const [form, setForm] = useState({
    name: '',
    address: '',
    state: '',
    city: '',
    pincode: '',
    gst_no: '',
    pan_no: '',
    remark: ''
  });

  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false); // ✅ added
  const navigate = useNavigate();
  const { id, distributor_token } = useParams();

  const getUserId = () => {
    const token = localStorage.getItem('token');
    try {
      const user = JSON.parse(atob(token));
      return user?.id || 0;
    } catch {
      return 0;
    }
  };

  useEffect(() => {
    if (id && distributor_token) {
      setEditMode(true);
      axios.post(GET_DISTRIBUTOR_DATA_ENDPOINT, { id, distributor_token })
        .then(res => {
          if (res.data.success && res.data.distributor) {
            setForm({
              name: res.data.distributor.name || '',
              address: res.data.distributor.address || '',
              state: res.data.distributor.state || '',
              city: res.data.distributor.city || '',
              pincode: res.data.distributor.pincode || '',
              gst_no: res.data.distributor.gst_no || '',
              pan_no: res.data.distributor.pan_no || '',
              remark: res.data.distributor.remark || ''
            });
          } else {
            toast.error(res.data.message || 'Failed to load distributor');
          }
        })
        .catch(() => toast.error('Error loading distributor data'));
    }
  }, [id, distributor_token]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const user_id = getUserId();
    if (!user_id) {
      toast.error("Invalid or missing token");
      return;
    }

    const payload = { ...form, user_id };
    if (editMode) {
      payload.id = id;
      payload.distributor_token = distributor_token;
    }

    setLoading(true); // ✅ start loading
    try {
      const res = await axios.post(DISTRIBUTOR_SAVE_ENDPOINT, payload);
      if (res.data.success) {
        toast.success(res.data.message || 'Distributor saved successfully');
        setTimeout(() => navigate('/distributors/show'), 1200);
      } else {
        toast.error(res.data.message || 'Failed to save distributor');
      }
    } catch {
      toast.error('Server error while saving distributor');
    }
    setLoading(false); // ✅ stop loading
  };

  return (
    <>
      <MasterNavbar />
      <Toaster position="top-center" />
      <div className="container mt-5">
        <div className="card shadow p-4 mx-auto" style={{ maxWidth: '700px' }}>
          <h4 className="mb-4 text-center">
            {editMode ? '✏️ Edit Distributor' : '➕ Add New Distributor'}
          </h4>

          <input type="text" name="name" value={form.name} onChange={handleChange} className="form-control mb-3" placeholder="Distributor Name" />
          <textarea name="address" value={form.address} onChange={handleChange} className="form-control mb-3" placeholder="Address" />
          <input type="text" name="state" value={form.state} onChange={handleChange} className="form-control mb-3" placeholder="State" />
          <input type="text" name="city" value={form.city} onChange={handleChange} className="form-control mb-3" placeholder="City" />
          <input type="text" name="pincode" value={form.pincode} onChange={handleChange} className="form-control mb-3" placeholder="Pincode" />
          <input type="text" name="gst_no" value={form.gst_no} onChange={handleChange} className="form-control mb-3" placeholder="GST No" />
          <input type="text" name="pan_no" value={form.pan_no} onChange={handleChange} className="form-control mb-3" placeholder="PAN No" />
          <textarea name="remark" value={form.remark} onChange={handleChange} className="form-control mb-4" placeholder="Remark" />

          <button
            className="btn btn-primary w-100"
            onClick={handleSubmit}
            disabled={loading} // ✅ disable while loading
          >
            {loading
              ? (editMode ? 'Updating...' : 'Saving...')
              : (editMode ? 'Update Distributor' : 'Save Distributor')}
          </button>
        </div>
      </div>
    </>
  );
}

export default DistributorsAdd;
